export default __webpack_public_path__ + "static/media/Ballroll_00081.9b0e40af.png";